export default {
  'button.add': 'Add',
  'button.edit': 'Edit',
  'button.delete': 'Delete',
  'button.search': 'Search',
  'button.reset': 'Reset',
  'button.confirm': 'Confirm',
  'button.cancel': 'Cancel',
  'button.back': 'Back',
  'button.save': 'Save',
  'button.view': 'View',
  'button.export': 'Export',
  'button.import': 'Import',
};
